import { formatPrice, formatPricePerHour, formatPricePerSession } from '@wecasa/common/src/utils/formatting';

import type { Price, PromotionPrice, StandardPrices } from '../types/prices';

export const getFormattedPrice = (hasDuration: boolean, price?: Price) =>
  hasDuration ? formatPrice(price?.price) : formatPricePerHour(price?.hourly_price);

export const getFormattedPriceForMultiple = (hasDuration: boolean, price?: Price) =>
  hasDuration ? formatPricePerSession(price?.price) : formatPricePerHour(price?.hourly_price);

export type PlatformFees = {
  firstSessionPrice: Price;
  followingSessionsPrice: Price;
  feeSurchargePerHour: number;
};

export const getPlatformFees = (prices?: StandardPrices): PlatformFees | undefined => {
  if (!prices) return undefined;

  const platformFeesSurcharge = prices.surcharges?.find((surcharge) => surcharge.type === 'platform_fees');
  const beforePlatformFees = prices.before_platform_fees;

  if (!beforePlatformFees || !(platformFeesSurcharge && platformFeesSurcharge.hourly_price > 0)) return undefined;

  return {
    firstSessionPrice: prices.total,
    followingSessionsPrice: beforePlatformFees,
    feeSurchargePerHour: platformFeesSurcharge.hourly_price,
  };
};

export const getFormattedPromotion = (hasDuration: boolean, promotion?: PromotionPrice) => {
  const showPromotionPerHour = promotion?.calculation_type === 'per_hour' && !hasDuration;
  return showPromotionPerHour ? formatPricePerHour(promotion?.hourly_price) : formatPrice(promotion?.price);
};
